export const callWFAPI = async (
  moduleId: number,
  type: string,
  params: object,
): Promise<any> => {
  const data = {
    id: 1,
    domain: 'websiteforge.com',
    wfuserlogin: 'custom-transfers',
    wfuserpassword: 'ggkAqbpNUj',
    moduleid: moduleId,
    type: type,
    data: params,
  }
  let previewPrefix = ''
  if (
    typeof location !== 'undefined' &&
    location.pathname.indexOf('preview/') != -1
  ) {
    previewPrefix = 'preview/'
  }
  const response = await fetch(
    `https://www.custom-transfers.com/${previewPrefix}core/webservice`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    },
  )
  if (!response.ok) {
    throw new Error(`API Error: ${response.status}`)
  }
  const resp = await response.json()
  if (resp['ErrorText']) {
    throw new Error(resp['ErrorText'])
  }
  return resp['Data']
}

export const uploadImage = async (
  sessionKey: string,
  contentOrUrl: string,
  fileName: string = 'image',
) => {
  const isUrl =
    contentOrUrl.startsWith('http://') || contentOrUrl.startsWith('https://')

  const params: Record<string, any> = {
    name: fileName,
    temp: 1,
    dir: 'sticker-builder/' + sessionKey,
  }

  if (isUrl) {
    params.url = contentOrUrl
  } else {
    params.base64content = contentOrUrl
  }

  const resp = await callWFAPI(0, 'uploadFile', params)
  return resp.path
}

export const reloadBuilder = (navigate?: (path: string) => void) => {
  if (typeof parent !== 'undefined' && typeof location !== 'undefined') {
    if (parent != window) {
      parent.postMessage({type: 'reload'}, location.origin)
    }
    else {
      location.href = location.pathname;
    }
  } else if (navigate) {
    navigate('/stickers')
  }
}